export default "/imgs/investigation-05-mob.png"